import { create } from 'zustand';
import { OrganizationSettingsInterface } from '../interfaces/organizationSettings.interface';
import {string} from "yup";

interface OrganizationSettingsState {
  organizationSettings: OrganizationSettingsInterface,
  setOrganizationSettings: (_newOrganizationSettings: OrganizationSettingsInterface) => void,
}

interface OrganizationState {
  selectedOrganization: any,
  setSelectedOrganization: (_newOrganizationSettings: any) => void,
}
export const useOrganizationSettingsStore = create<OrganizationSettingsState>((set) => ({
  organizationSettings: {
    isSnapchatActive: false,
    finalUrlSuffixUpdatedAt: new Date().toISOString(),
  },
  setOrganizationSettings: (newOrganizationSettings) => set(() => ({
    organizationSettings: newOrganizationSettings,
  })),
}));

export const useOrganizationStore = create<OrganizationState>((set) => ({
  selectedOrganization: null,
  setSelectedOrganization: (organization) => set({ selectedOrganization: organization }),
}));
